import React, { useState, useEffect } from "react";

import "../assets/scss/pages/_subscriptions.scss";

import Sunflowers from "../assets/images/lifestyles/sunflowers.jpg";
import LaBelle from "../assets/images/lifestyles/labelle.jpg";
import RoseLil from "../assets/images/lifestyles/roselil.jpg";
import WildAndWonderful from "../assets/images/lifestyles/wildandwonderful.jpg";
import Katherine from "../assets/images/lifestyles/2025-katherine.jpg";
import PeruvianRoseLily from "../assets/images/lifestyles/2025-peruvian-lily-rose.jpg";
import Alexandra from "../assets/images/lifestyles/2025-alexandra.jpg";
import TulipDelights from "../assets/images/lifestyles/2025-tulip-delights.jpg";

import { useProductStore } from "../stores/ProductStore";
import { useMetaStore } from "../stores/MetaStore";
import { DeliverySection } from "../components/DeliverySection";

import { Image } from "../components/Image";

export const Subscriptions = () => {
	const [selectedSubscription, setSelectedSubscription] = useState(null);
	const [showFullAddress, setShowFullAddress] = useState(false);

	const { info, GetInfo, AddToCart, SetSize } = useProductStore((state) => state);

	useEffect(() => {
		GetInfo(1118, true);

		useMetaStore.getState().SetMeta({
			title: "Subscriptions",
			description: "Enjoy regular beautiful fresh flowers with 123 Subscriptions."
		});
	}, [GetInfo]);

	return (
		<section className="subscriptions-page-container">
			<div className="header-information-container">
				<section className="header-information">
					<div className="container">
						<div
							className="row align-items-center justify-content-space-between"
							style={{
								"--gap": "20px"
							}}
						>
							<div className="col-12 col-md-6">
								<h1>Weekly, Fornightly or Monthly Subscriptions</h1>
								<p>Enjoy regular beautiful fresh flowers with 123 Subscriptions.</p>
								<a href="#subscription-select">Choose My Subscription</a>
							</div>
							<div className="col-12 col-md-6">
								<Image
									src={Katherine}
									className="header-image"
									alt="Katherine"
								/>
							</div>
						</div>
					</div>
				</section>
			</div>

			{1 == 2 && (
				<div className="subscription-usps-container">
					<div className="container">
						<section className="subscription-usps row align-items-stretch justify-content-space-between">
							<div className="usp col-6 col-md-fluid">Pause or Cancel Anytime</div>
							<div className="usp col-6 col-md-fluid">Freshest florist picks</div>
							<div className="usp col-6 col-md-fluid">Delivered straight to your door</div>
							<div className="usp col-6 col-md-fluid">Free standard delivery</div>
						</section>
					</div>
				</div>
			)}

			<div className="how-it-works-container container">
				<section className="how-it-works-section row align-items-stretch justify-content-space-between">
					<div className="col-12 how-it-works-title">
						<h2>How It Works</h2>
					</div>
					<div className="how-it-works col-12 col-md-4">
						<Image
							src={PeruvianRoseLily}
							alt="Peruvian Rose Lily"
						/>
						<p>Choose your package from our wide range of varieties and durations, we will send you the freshest florist picks</p>
					</div>
					<div className="how-it-works col-12 col-md-4">
						<Image
							src={Alexandra}
							alt="Alexandra"
						/>
						<p>Enter your address, choice of delivery date and payment method</p>
					</div>
					<div className="how-it-works col-12 col-md-4">
						<Image
							src={TulipDelights}
							alt="Tulip Delights"
						/>
						<p>We will handle the rest! Sit back, relax and await your lovely flowers with free delivery!</p>
					</div>
				</section>
			</div>

			<div
				className="choose-your-subscription-wrapper"
				id="subscription-select"
			>
				<section className="choose-your-subscription row align-items-stretch justify-content-lg-space-between container">
					<h1 className="col-12">Choose Your Subscription!</h1>
					<div className={`subscription-choice col-12 col-md-fluid ${selectedSubscription !== null && selectedSubscription !== "weekly" ? "disabled" : ""}`}>
						<h2>
							Weekly
							<br />
							Package
						</h2>
						<div className="price">
							<strong>£20.00</strong>
							<span>
								per seasonal flowers subscription <br />
								(4 bouquets/pm)
							</span>
						</div>
						<button
							className="btn"
							onClick={(e) => {
								setSelectedSubscription("weekly");
								SetSize("weekly");
							}}
						>
							Choose Package
						</button>
					</div>
					<div className={`subscription-choice col-12 col-md-fluid ${selectedSubscription !== null && selectedSubscription !== "fortnightly" ? "disabled" : ""}`}>
						<h2>
							Fortnightly
							<br />
							Package
						</h2>
						<div className="popular">Popular</div>
						<div className="price">
							<strong>£20.00</strong>
							<span>
								per seasonal flowers subscription <br />
								(2 bouquets/pm)
							</span>
						</div>
						<button
							className="btn"
							onClick={(e) => {
								setSelectedSubscription("fortnightly");
								SetSize("fortnightly");
							}}
						>
							Choose Package
						</button>
					</div>
					<div className={`subscription-choice col-12 col-md-fluid ${selectedSubscription !== null && selectedSubscription !== "monthly" ? "disabled" : ""}`}>
						<h2>
							Monthly
							<br />
							Package
						</h2>
						<div className="price">
							<strong>£20.00</strong>
							<span>
								per seasonal flowers subscription <br />
								(1 bouquets/pm)
							</span>
						</div>
						<button
							className={`btn`}
							onClick={(e) => {
								setSelectedSubscription("monthly");
								SetSize("monthly");
							}}
						>
							Choose Package
						</button>
					</div>
				</section>
			</div>

			{selectedSubscription !== null && (
				<div className="address-information-wrapper">
					<section className="address-information container">
						<h1>Enter Your Delivery Information</h1>
						{info && info.delivery && info.delivery.upcoming_dates && info.delivery.upcoming_dates[0] && (
							<DeliverySection
								showDeliveryOptions={false}
								showFullAddress={showFullAddress}
								setShowFullAddress={setShowFullAddress}
							/>
						)}

						<button
							className="btn finalise-subscription"
							onClick={() => {
								AddToCart(info);
							}}
						>
							Add To Cart
						</button>
					</section>
				</div>
			)}
		</section>
	);
};

export default Subscriptions;
